/**
 * Compteur maison (compteur.php sur le même hébergement) — totaux anonymes,
 * aucun cookie, aucune donnée personnelle.
 * sendBeacon survit au départ de la page ; fetch en secours.
 */
export const track = (event) => {
  try {
    const url = `${process.env.PUBLIC_URL}/compteur.php`;
    const payload = JSON.stringify({ event });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(url, { method: 'POST', body: payload, keepalive: true }).catch(() => {});
    }
  } catch (e) { /* le comptage ne doit jamais rien casser */ }
};

/**
 * Compte une visite du site :
 *  - `page_vue` à chaque chargement du site ;
 *  - `visiteur_jour` une seule fois par jour et par navigateur
 *    (≈ visiteurs uniques du jour).
 */
export const trackVisit = () => {
  track('page_vue');
  try {
    const today = new Date().toISOString().slice(0, 10);
    if (localStorage.getItem('familys_visite_jour') !== today) {
      localStorage.setItem('familys_visite_jour', today);
      track('visiteur_jour');
    }
  } catch (e) { /* navigation privée : on compte au moins la page vue */ }
};
